import { useParams } from "react-router-dom";
import { Input } from "../../Input";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { useAuth } from "../../../providers/Auth";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { FormMaterialImpressoStyle } from "./style";
import QuantidadeBriefing from "../../QuantidadeBriefing";
import { QuantidadeBriefingStyled } from "../../QuantidadeBriefing/styles";

export const FormMaterialImpresso = ({
  itens,
  categoriaSelecionada,
  clienteId,
  dataBriefing,
  setAbrirModalPedirRevisao,
}) => {
  const { user, token } = useAuth();
  const [files, setFiles] = useState([]);
  const [indexQuantidade, setIndexQuantidade] = useState([1]);
  const [travarBotao, setTravarBotao] = useState(false);
  const [substratos, setSubstratos] = useState([]);

  const { id } = useParams();

  const adicionarHistorico = (dados) => {
    const data = {
      tipo: "Campanha",
      texto: `Adicionado Novo Briefing: Produto de Material Impresso ${dados.nome} [Id: ${dados.id}]`,
      campanha_id: id,
    };

    api
      .post("/historico-campanha", [data])
      .then((response) => { })
      .catch((error) => {
        toast.error("Erro ao salvar no historico");
      });
  };

  function listarSubstratos() {
    api
      .get("/substrato")
      .then((response) => {
        setSubstratos(response.data.data.substratos);
        reset({ substrato_id: dataBriefing ? dataBriefing.substrato_id : "" });
      })
      .catch((error) => {
        toast.error("Erro ao salvar no historico");
      });
  };

  const adicionarHistoricoAtualizar = () => {
    api
      .get(`/campanha-material-briefing/briefing/${id}`)
      .then((response) => {
        const dados = response.data.data.materiais;
        const data = {
          tipo: "Campanha",
          texto: `Briefing Atualizado: Produto Material Impresso ${dados.nome} [Id: ${dados.id}]`,
          campanha_id: dados.campanhas_id,
        };

        api
          .post("/historico-campanha", [data])
          .then((response) => { })
          .catch((error) => {
            toast.error("Erro ao salvar no historico");
          });
      })
      .catch((error) => {
        console.error("Erro ao buscar dados da API:", error);
        toast.error("Erro ao buscar dados");
      });
  };

  const {
    register,
    handleSubmit,
    getValues,
    unregister,
    formState: { errors },
    reset,
  } = useForm({
    // resolver: yupResolver(schemaComunicacaoVisual),
  });

  const chaves = [
    "corte_de_faca",
    "dobra",
    "encadernacao_espiral",
    "encadernacao_grampos",
    "encadernacao_lombada",
    "encadernacao_wire",
    "laminacao_brilho",
    "laminacao_fosca",
    "refile",
    "verniz_uv_reserva",
    "verniz_uv_total",
  ];

  const enviarData = (data) => {
    const arrayTexto = [];

    if (getValues("nome") === "Selecionar Material") {
      return toast.error("Selecione um item");
    }

    for (let i = 0; i < chaves.length; i++) {
      if (getValues(chaves[i]) != false) {
        arrayTexto.push(getValues(chaves[i]));
      }
    }

    const acabamentos = arrayTexto.join(", ");

    setTravarBotao(true);

    const parte = data.prazo_maximo.split("-");
    data.prazo_maximo = `${parte[2]}/${parte[1]}/${parte[0]}`;
    const objetoExemplo = {
      categoria: categoriaSelecionada,
      nome: data.nome,
      descricao: data.descricao,
      substrato: data.substrato_material,
      cores: data.cor,
      preco_maximo_unidade: data.preco_maximo_unidade,
      prazo_maximo: data.prazo_maximo,
      endereco: data.endereco,
      item_id: itens.filter((element) => element.nome == data.nome)[0].id,
      campanhas_id: dataBriefing ? dataBriefing.campanhas_id : id,
      status: dataBriefing ? dataBriefing.status : "enviado pra orçamento",
      criador_id: clienteId,
      acabamentos: acabamentos,
      formato_aberto: data.formato_aberto,
      gramatura: data.gramatura,
      quantidade_de_paginas: data.quantidade_de_paginas,
      formato_fechado: data.formato_fechado,
      subnome: data.subnome,
      substrato_id: data.substrato_id,
    };

    if (dataBriefing) {
      api
        .patch(`/campanha-material-briefing/${id}`, objetoExemplo, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          toast.success("Briefing Atualizado! 🎉");
          adicionarHistoricoAtualizar();
          setTimeout(() => {
            window.history.back();
          }, 2000);
        })
        .catch((error) => {
          toast.error("Algo deu Errado. Tente novamente.");
        });
    } else {
      api
        .post(
          "/campanha-material-briefing",
          { materiaisBriefing: [objetoExemplo] },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          toast.success("Briefing Criado! 🎉");
          adicionarHistorico(response.data.data.campanha);

          const arrayObjetoQuantidade = [];

          for (let i = 0; i < indexQuantidade.length; i++) {
            const quantidade = getValues(`quantidade${indexQuantidade[i]}`);
            if (quantidade) {
              arrayObjetoQuantidade.push({
                quantidade: Number(quantidade),
                campanha_materiais_briefing_id: response.data.data.campanha.id,
              });
            }
          }

          api
            .post("/briefing-quantidade", { materiais: arrayObjetoQuantidade })
            .then((responseBriefing) => { })
            .catch((error) => {
              toast.error("Erro ao salvar no historico");
            });

          const formData = new FormData();

          files.forEach((foto, index) => {
            formData.append(`fotos[${index}]`, foto);
          });

          api
            .post(
              `/campanha-material-briefing/${response.data.data.campanha.id}/anexos`,
              formData,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            )
            .then((response) => { })
            .catch((error) => { });
          setTimeout(() => {
            window.history.back();
          }, 1000);
        })
        .catch((error) => {
          toast.error("Algo deu Errado. Tente novamente.");
          setTravarBotao(false);
        });
    }
  };

  async function aprovarDetalhes() {
    api
      .patch(
        `/campanha-material-briefing/${id}`,
        { aprovacao_produtor: 1 },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success("Briefing Atualizado! 🎉");
        adicionarHistoricoAtualizar();
        setTimeout(() => {
          window.history.back();
        }, 2000);
      })
      .catch((error) => {
        toast.error("Algo deu Errado. Tente novamente.");
      });
  }

  useEffect(() => {
    if (!substratos.length) {
      listarSubstratos();
    }
  }, [substratos]);

  useEffect(() => {
    if (dataBriefing) {
      const copia = { ...dataBriefing };
      copia.cor = copia.cores;
      copia.prazo_maximo = copia.prazo_maximo
        ? copia.prazo_maximo.split("/").reverse().join("-")
        : "";
      reset(copia);
    }
  }, [dataBriefing, reset]);


  function removerArquivo(index) {
    // Crie uma cópia do array files
    const novaListaArquivos = [...files];
    // Remova o item do índice específico
    novaListaArquivos.splice(index, 1);
    // Atualize o estado files com a nova lista
    setFiles(novaListaArquivos);
  }

  return (
    <FormMaterialImpressoStyle onSubmit={handleSubmit(enviarData)}>
      <div className="div-category-name">
        <div className="div-category"></div>
        <div className="input-completo item select-nome">
          <label>Nome do Material</label>
          <select className="input-name select " {...register("nome")}>
            <option value={undefined}>Selecionar Material</option>
            {itens &&
              itens
                .filter(
                  (elemen) => elemen.categoria_item_id == categoriaSelecionada
                )
                .map((element) => <option>{element.nome}</option>)}
          </select>
        </div>
        <div className="input-completo item">
          <Input
            label="Descrição do Material"
            type="text"
            placeholder="Edição Especial 1997"
            register={register("subnome")}
            className="input-name select"
          />
          {errors.subnome && (
            <span className="input-error">{errors.subnome.message}</span>
          )}
        </div>
      </div>
      <div className="grid">
        <div className="flex row tres">
          <div className="input-completo">
            <Input
              label="Quantidade de páginas"
              type="number"
              placeholder="1, 2, 4, 16, etc."
              register={register("quantidade_de_paginas")}
              className="input-grid"
              min={1}
            />
            {errors.quantidade_de_paginas && (
              <span className="input-error">
                {errors.quantidade_de_paginas.message}
              </span>
            )}
          </div>
          <div className="input-completo">
            <Input
              label="Formato aberto (em cm)"
              type="text"
              placeholder="Largura x Altura"
              register={register("formato_aberto")}
              className="input-grid"
              min={0}
              step="0.01"
            />
            {errors.formato_aberto && (
              <span className="input-error">
                {errors.formato_aberto.message}
              </span>
            )}
          </div>
          <div className="input-completo">
            <Input
              label="Formato fechado (em cm)"
              type="text"
              placeholder="Largura x Altura"
              register={register("formato_fechado")}
              step="0.01"
              className="input-grid"
            />
            {errors.formato_fechado && (
              <span className="input-error">
                {errors.formato_fechado.message}
              </span>
            )}
          </div>
        </div>
        <div className="flex row tres">
          <div className="substrato">
            <label>Substrato/Gramatura</label>
            <select className="input-name select-substrato" {...register("substrato_id")}>
              <option value="" hidden>Selecionar Substrato/Gramatura</option>
              {substratos &&
                substratos.map((element) => <option value={element.id}>{element.nome} | {element.gramatura_espessura}</option>)}
            </select>
          </div>
          <div className="input-completo">
            <Input
              label="Quantidade de cores"
              type="text"
              placeholder="4x0, 4x1, 4x2, etc."
              register={register("cor")}
              className="input-grid"
            />
            {errors.cor && (
              <span className="input-error">{errors.cor.message}</span>
            )}
          </div>
        </div>
        <div className="flex row">
          <div className="column">
            <label>
              Acabamentos (selecione todos que deseja em seu material)
            </label>
            <div className="flex-check">
              <div className="check-input aling">
                <input value="refile" type="checkbox" {...register("refile")} />
                <label>Refile</label>
              </div>
              <div className="check-input aling">
                <input value="Dobra" {...register("dobra")} type="checkbox" />
                <label>Dobra</label>
              </div>
              <div className="check-input aling">
                <input
                  type="checkbox"
                  value="Corte de faca especial"
                  {...register("corte_de_faca")}
                />
                <label>Corte de faca especial</label>
              </div>
              <div className="check-input aling">
                <input
                  type="checkbox"
                  value="Verniz UV Total"
                  {...register("verniz_uv_total")}
                />
                <label>Verniz UV Total</label>
              </div>
              <div className="check-input aling">
                <input
                  value="Verniz UV com reserva"
                  {...register("verniz_uv_reserva")}
                  type="checkbox"
                />
                <label>Verniz UV com reserva</label>
              </div>
              <div className="check-input aling">
                <input
                  value="Laminação fosca"
                  type="checkbox"
                  {...register("laminacao_fosca")}
                />
                <label>Laminação fosca</label>
              </div>
              <div className="check-input aling">
                <input
                  value="Laminação brilho"
                  type="checkbox"
                  {...register("laminacao_brilho")}
                />
                <label>Laminação brilho</label>
              </div>
              <div className="check-input aling">
                <input
                  value="Encadernação de 2 grampos"
                  type="checkbox"
                  {...register("encadernacao_grampos")}
                />
                <label>Encadernação de 2 grampos</label>
              </div>
              <div className="check-input aling">
                <input
                  value="Encadernação de espiral"
                  type="checkbox"
                  {...register("encadernacao_espiral")}
                />
                <label>Encadernação de espiral</label>
              </div>
              <div className="check-input aling">
                <input
                  value="Encadernação de wire-o"
                  type="checkbox"
                  {...register("encadernacao_wire")}
                />
                <label>Encadernação de wire-o</label>
              </div>
              <div className="check-input aling">
                <input
                  value="Encadernação de lombada quadrada"
                  type="checkbox"
                  {...register("encadernacao_lombada")}
                />
                <label>Encadernação de lombada quadrada</label>
              </div>
            </div>
          </div>
        </div>
        <div className="flex row quatro">
          {!dataBriefing
            ? indexQuantidade.map((index, outerIndex) => (
              <QuantidadeBriefing
                key={index}
                index={index}
                outerIndex={outerIndex}
                register={register}
                errors={errors}
                indexQuantidade={indexQuantidade}
                setIndexQuantidade={setIndexQuantidade}
                getValues={getValues}
                unregister={unregister}
              />
            ))
            : dataBriefing.quantidades.map((quantidade, outerIndex) => (
              <QuantidadeBriefingStyled>
                <div className="input-completo item">
                  <input
                    className="input-name select"
                    value={quantidade.quantidade}
                  />
                </div>
              </QuantidadeBriefingStyled>
            ))}
          <span
            onClick={() => {
              setIndexQuantidade([
                ...indexQuantidade,
                indexQuantidade[indexQuantidade.length - 1] + 1,
              ]);
            }}
            className="adicionar-quantidade"
            hidden={dataBriefing ? true : false}
          >
            Adicionar Quantidade
          </span>
        </div>
      </div>
      <div className="div-prazo-endereco ">
        <div className="input-completo data">
          <Input
            label="Estimativa de Data de entrega"
            type="date"
            placeholder="00/00/0000"
            register={register("prazo_maximo")}
            className="input-data"
          />
          {errors.prazo_maximo && (
            <span className="input-error">{errors.prazo_maximo.message}</span>
          )}
        </div>
        <div className="input-completo">
          <Input
            label="Local da entrega"
            type="text"
            placeholder="Ao menos o estado do destino ou se este item terá alguma distribuição executada por nós"
            register={register("endereco")}
            className="input-name"
          />
          {errors.endereco && (
            <span className="input-error">{errors.endereco.message}</span>
          )}
        </div>
      </div>
      <div className="input-completo">
        <Input
          label="Observações"
          type="text"
          placeholder="Observações"
          register={register("descricao")}
          className="input-description"
        />
        {errors.descricao && (
          <span className="input-error">{errors.descricao.message}</span>
        )}
      </div>
      <div>
        <label className="label-div-file">Upload do arquivo</label>
        <input
          {...register("file")}
          type="file"
          id="file"
          accept="image/*"
          multiple={true}
          onChange={(e) => {
            setFiles([...e.target.files, ...files]);
          }}
        />
        <div className="div-file">
          <label className="label-file" for="file">
            Arraste e solte arquivos aqui ou{" "}
            <span className="red">pesquise em seu computador</span>
          </label>
        </div>
      </div>
      {files.length > 0 &&
        files.map((elem, outerIndex) => (
          <div className="relative" key={outerIndex}>
            <div>
              <h5>{elem.name}</h5>
              <span onClick={() => removerArquivo(outerIndex)}>X</span>
            </div>
          </div>
        ))}
      {dataBriefing ? (
        <button className="button">Atualizar</button>
      ) : (
        <button className="button" hidden={travarBotao}>
          Adicionar
        </button>
      )}
      {(dataBriefing &&
        user.permissoes.includes("atendimento") &&
        dataBriefing.aprovacao_produtor === 0) ||
        (dataBriefing &&
          dataBriefing.aprovacao_produtor === 0 &&
          user.permissoes.includes("admin")) ||
        (dataBriefing && user.permissoes.includes("produtor")) ? (
        <span className="button" onClick={() => aprovarDetalhes()}>
          Aprovar
        </span>
      ) : (
        ""
      )}
      {user.permissoes.includes("admin") && dataBriefing && (
        <button
          className="button"
          onClick={() => setAbrirModalPedirRevisao(true)}
        >
          Pedir Revisão
        </button>
      )}
    </FormMaterialImpressoStyle>
  );
};
